module.exports = __webpack_public_path__ + "assets/images/logo.3aad4f6c.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/logo.svg
// module id = 42
// module chunks = 0